import { ShippingCoverageZodSchema } from "@redotech/redo-model/integration/redo-in-shipping/ris";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export interface UpdateRisIntegrationDef {
  name: "updateRisIntegration";
  input: z.ZodObject<{
    teamId: z.ZodType<string>;
    integrationType: z.ZodString;
    integration: z.ZodNullable<typeof ShippingCoverageZodSchema>;
  }>;
  output: z.ZodNullable<typeof ShippingCoverageZodSchema>;
}

export const updateRisIntegration: UpdateRisIntegrationDef = {
  name: "updateRisIntegration" as const,
  input: z.object({
    teamId: zExt.objectId(),
    integrationType: z.string(),
    integration: ShippingCoverageZodSchema.nullable(),
  }),
  output: ShippingCoverageZodSchema.nullable(),
};
